enum AvailsResult {
  Available = 'AVAILABLE',
  NotAvailable = 'NOT AVAILABLE',
  MayBeAvailable = 'MAY BE AVAILABLE',
  PartiallyAvailable = 'PARTIALLY AVAILABLE',
}

export default AvailsResult;
